import { useEffect, useState } from 'react';
import InnerLayout from '../components/InnerLayout';

const FAQS = [
  { q: '¿Qué es Sttora?', a: 'Sttora es una red comercial global que integra tiendas de cercanía, centros de consolidación y comercio digital, orientada a mejorar la vida de las personas a través de una propuesta accesible, eficiente y humana.' },
  { q: '¿Cuándo estará disponible la plataforma?', a: 'La plataforma está actualmente en desarrollo. Registra tu correo en la página principal para recibir una notificación en cuanto esté disponible.' },
  { q: '¿Cómo puedo unirme a la red de distribuidores?', a: 'Para unirte como distribuidor autorizado, contacta a tu representante Sttora más cercano o escríbenos a contacto@sttora.com con tu información y región de interés.' },
  { q: '¿Qué tipos de productos ofrece Sttora?', a: 'Sttora ofrece productos esenciales del hogar, alimentos, cuidado personal, servicios de conveniencia y soluciones para el hogar, con un catálogo en constante expansión.' },
  { q: '¿Cómo funciona el Centro de Negocios?', a: 'El Centro de Negocios es tu herramienta de gestión como distribuidor: seguimiento de pedidos, gestión de tu red, acceso a material de apoyo, estadísticas y herramientas de crecimiento.' },
  { q: '¿En qué países opera Sttora?', a: 'Sttora opera actualmente en mercados de América Latina y está en proceso de expansión. Consulta la sección de Mercados Emergentes para ver los países activos y próximos lanzamientos.' },
  { q: '¿Cómo me contacto con soporte?', a: 'Puedes escribirnos a contacto@sttora.com o utilizar el formulario en la sección Contacto. Nuestro equipo responde en un plazo máximo de 48 horas hábiles.' },
];

const CATS = ['Todos', 'Cuenta', 'Pedidos', 'Pagos', 'Envíos', 'Devoluciones', 'Plataforma'];

export default function CentroAyuda() {
  useEffect(() => { document.title = 'Centro de Ayuda — Sttora'; }, []);
  const [openIndex, setOpenIndex] = useState(0);
  const [activeCat, setActiveCat] = useState(0);

  return (
    <InnerLayout titleFirst="Centro de" titleAccent="Ayuda" subtitle="Encuentra respuestas a las preguntas más frecuentes sobre Sttora." breadcrumb="Centro de Ayuda">
      <div className="help-categories">
        {CATS.map((c, i) => (
          <button key={c} className={`help-cat${activeCat === i ? ' active' : ''}`} onClick={() => setActiveCat(i)}>{c}</button>
        ))}
      </div>
      <div className="section-label" style={{ marginBottom: '1.5rem' }}>Preguntas frecuentes</div>
      <div className="faq-list">
        {FAQS.map((faq, i) => (
          <div key={i} className={`faq-item${openIndex === i ? ' open' : ''}`}>
            <button className="faq-question" onClick={() => setOpenIndex(openIndex === i ? -1 : i)}>
              {faq.q}
              <span className="faq-icon" aria-hidden="true" />
            </button>
            <div className="faq-answer"><p>{faq.a}</p></div>
          </div>
        ))}
      </div>
    </InnerLayout>
  );
}
